import haf from "./images/havko.png";
import Background01 from "../src/images/background01.png";
import Background02 from "../src/images/background02.png";
import Logo from "../src/images/logo.png";
import { useTranslation } from "react-i18next";

import "../src/styles/Background.scss";
import "../src/styles/CheckEmailError.scss";

function CheckMailErrPage() {
  const { t } = useTranslation();
  return (
    <div className="content2">
      <img className="background01" src={Background01} alt="waves orange" />
      <img className="background02" src={Background02} alt="waves blue" />
      <a href="https://zooza.sk/signup">
        <img className="logo2" src={Logo} alt="zooza logo" />
      </a>
      <div className="middle">
        <img className="havko" src={haf} alt="hafko" />
        <h1 style={{ margin: 20 }}>{t("signup__token_not_found")}</h1>
        <h3 style={{ margin: 20 }}>{t("signup__try_again")}</h3>
      </div>
    </div>
  );
}

export default CheckMailErrPage;
